import * as React from 'react';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'shared/utils/hooks/useRedux';
import { useLocation } from 'react-router-dom';
import { useFormRedux } from 'shared/utils/hooks/useFormRedux';
import { updateField } from 'entities/cancer-protection/step-1';
import { validationSchema } from 'entities/cancer-protection/step-1/utils/validationSchema';
import { FormFieldsStepOne, Programs } from 'entities/cancer-protection/step-1/selector';
import { risksArray } from 'features/cancer-protection/step-1/utils/RisksData';
import { fetchDictionaries } from 'entities/cancer-protection/step-1/action/fetch-step-one';
import * as yup from 'yup';
import { InsuredBirthDate } from './ui/InsuredBirthDate';
import { IStepOne } from 'entities/cancer-protection/step-1/types/StepOne-interface';
import { SelectProgram } from './ui/SelectProgram';

interface IPropsStepOne {
    windowWidth: number;
    handleNext: () => void;
}

enum Steps {
    InsuredBirthDate = "InsuredBirthDate",
    Program = "Program"
}

export const StepOne: React.FC<IPropsStepOne> = ({ windowWidth, handleNext }) => {
    const dispatch = useAppDispatch();
    const location = useLocation();

    const [currentStep, setCurrentStep] = useState<Steps>(Steps.InsuredBirthDate);

    const {
        formState,
        handleChange,
        handleBlur,
        errors,
        setErrors,
        handleAutocompleteChange,
        validateForm,
        handleDateChange,
        handleCheckboxChange
    } = useFormRedux(
        (state) => state.stepOneCancer,
        updateField,
        validationSchema
    );

    const { AgentSalesDataID } = useAppSelector(FormFieldsStepOne);
    const { isLoadingPrograms } = useAppSelector(Programs);

    const validateInsuredBirthDateStep = async () => {
        try {
            const schema = validationSchema;
            await schema.validate(formState, { abortEarly: false });
            setErrors({});
            return true;
        } catch (err) {
            if (err instanceof yup.ValidationError) {
                const newErrors: Record<string, string> = {};
                err.inner.forEach((error) => {
                    if (error.path) {
                        newErrors[error.path] = error.message;
                    }
                });
                setErrors(newErrors);
                return false;
            }
            return false;
        }
    };

    const wrappedHandleBlur = (fieldName: keyof IStepOne) => (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const inputEvent = e as React.FocusEvent<HTMLInputElement>;
        handleBlur(fieldName)(inputEvent);
    };

    const handleNextStep = async () => {
        let isValid = false;
        switch (currentStep) {
            case Steps.InsuredBirthDate:
                isValid = await validateInsuredBirthDateStep();
                if (isValid) {
                    dispatch(fetchDictionaries({ agentSalesDataID: AgentSalesDataID, insuredBirthDate: formState.InsuredBirthDate })).then(() => setCurrentStep(Steps.Program));
                }
                break;
            case Steps.Program:
                break;
            default:
                break;
        }
    };

    const handleBack = () => {
        switch (currentStep) {
            case Steps.Program:
                setCurrentStep(Steps.InsuredBirthDate);
                break;
            default:
                break;
        }
    };
    const setProgramId = (id: string) => {
        dispatch(updateField({ field: 'ProgramId', value: id }));
    };
    return (
        <>
            {currentStep === Steps.InsuredBirthDate && (
                <InsuredBirthDate
                    formState={formState}
                    errors={errors}
                    handleDateChange={handleDateChange}
                    handleBlur={wrappedHandleBlur}
                    risksArray={risksArray}
                    handleNextStep={handleNextStep}
                    isLoadingPrograms={isLoadingPrograms}
                    windowWidth={windowWidth}
                />
            )}
            {currentStep === Steps.Program && (
                <SelectProgram
                    formState={formState}
                    errors={errors}
                    handleNext={handleNext}
                    handleBack={handleBack}
                    handleCheckboxChange={handleCheckboxChange}
                    setProgramId={setProgramId}
                    windowWidth={windowWidth}
                />
            )}

        </>

    );
};